import React from 'react';

export interface Props {
  className?: string;
}

const ArrowIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      fill="none"
      viewBox="0 0 8 8"
    >
      <path fill="currentColor" d="M8 0v8H0l8-8z"></path>
    </svg>
  );
};
ArrowIcon.displayName = 'ArrowIcon';

export default ArrowIcon;
